export const ADD_MOBILE_NUMBER = 'add-your-mobile-number';
export const MOBILE_NUMBER_CONFIRMED = 'mobile-number-confirmed';
